import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Badge, Container } from "react-bootstrap";

const Cart = () => {
    return (
    <>
        <Container className="py-5">
          <Row className="mx-0 breadcrumb_part">
              <h3>Your cart</h3>
              <Breadcrumb>
                  <Breadcrumb.Item>Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Cart</Breadcrumb.Item>
                  {/* <Breadcrumb.Item active>Thank You Cards</Breadcrumb.Item> */}
              </Breadcrumb>
          </Row>
        </Container>
    </>
  );
};

export default Cart;